import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FadeIn } from '../ui/FadeIn';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Realmente funcionan solo 10 minutos?',
  a: 'Sí, porque atacamos la biología, no la psicología.'
}, {
  q: '¿Necesito equipo especial?',
  a: 'No, solo tu respiración y este manual.'
}, {
  q: '¿Puedo hacerlo si comparto cama?',
  a: 'Absolutamente, es un proceso interno y silencioso.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-6 bg-white/40" data-id="element-12">
      <div className="max-w-3xl mx-auto" data-id="element-13">
        <FadeIn data-id="element-14">
          <h2 className="font-serif text-3xl md:text-4xl mb-12 text-center text-[#1C1917]" data-id="element-15">
            Preguntas Frecuentes
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-16">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-17">
              <div className="border border-[#E5E0D8] rounded-sm bg-white overflow-hidden" data-id="element-18">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-19">
                  <span className="font-medium text-[#1C1917] text-lg" data-id="element-20">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-[#C26D5C] transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-21" />
                </button>
                <AnimatePresence data-id="element-22">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-23">
                      <div className="px-6 pb-6 text-[#4A4541]" data-id="element-24">{faq.a}</div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}